import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
	AccidentIndemnityPlanPage,
	CancerPlanPage,
	ChristmasClubElectionPlanPage,
	ClinicCardPlanPage,
	CorePlansPage,
	CriticalIllnessPlanPage,
	DentalPlanPage,
	Error404,
	Footer,
	STDPlanPage,
	GroupLifeInsurance,
	GroupLongTermDisabilityClassAPlanPage,
	GroupLongTermDisabilityClassBPlanPage,
	GroupShortTermDisabilityPlanPage,
	HealthPlanPage,
	HelpingOurOwn,
	Home,
	HospitalIndemnityPlanPage,
	KSOPPlanPage,
	LimitedIndemnityPlanPage,
	Navbar,
	TeamLifePlanPage,
	VEBPlansPage,
	VisonPlanPage,
	WholeLifePlanPage,
	DocAndRxPlanPage,
	TermLifePlanPage
} from "./components";

const App: React.FC = (): JSX.Element => {
	return (
		<main>
			<div className="main">
				<div className="gradient" />
			</div>
			<div className="app">
				<Router>
					<Navbar />
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/plans">
							{/* ======================================= CORE-BENEFITS ======================================== */}
							<Route path="core">
								<Route index element={<CorePlansPage />} />
								<Route path="health-plan" element={<HealthPlanPage />} />
								<Route path="clinic-card" element={<ClinicCardPlanPage />} />
								<Route
									path="group-short-term-disability"
									element={<GroupShortTermDisabilityPlanPage />}
								/>
								<Route
									path="group-long-term-disability-class-1"
									element={<GroupLongTermDisabilityClassAPlanPage />}
								/>
								<Route
									path="group-long-term-disability-class-2"
									element={<GroupLongTermDisabilityClassBPlanPage />}
								/>
								<Route path="ksop" element={<KSOPPlanPage />} />
								<Route path="helping-our-own" element={<HelpingOurOwn />} />
								<Route path="group-life-insurance" element={<GroupLifeInsurance />} />
								<Route path="christmas-club-election" element={<ChristmasClubElectionPlanPage />} />
							</Route>
							{/* ======================================= VEB BENEFITS =============================================== */}
							<Route path="veb">
								<Route index element={<VEBPlansPage />} />
								<Route path="cancer-plan" element={<CancerPlanPage />} />
								<Route path="term-life-coverage" element={<TermLifePlanPage />} />
								<Route path="whole-life" element={<WholeLifePlanPage />} />
								<Route path="short-term-disability" element={<STDPlanPage />} />
								<Route path="critical-illness" element={<CriticalIllnessPlanPage />} />
								<Route path="hospital-indemnity" element={<HospitalIndemnityPlanPage />} />
								<Route path="accident-insurance" element={<AccidentIndemnityPlanPage />} />
								<Route path="limited-indemnity" element={<LimitedIndemnityPlanPage />} />
								<Route path="term-life-121" element={<TeamLifePlanPage />} />
								<Route path="doc-and-rx" element={<DocAndRxPlanPage />} />
								<Route path="vision" element={<VisonPlanPage />} />
								<Route path="dental" element={<DentalPlanPage />} />
							</Route>
						</Route>
						<Route path="*" element={<Error404 />} />
					</Routes>
					<Footer />
				</Router>
			</div>
		</main>
	);
};

export default App;
